import {RouteTabParameter} from '../../types/common/RouteTabParameter';


export interface InstructorPaths {
    InstructorEdit: string,
    InstructorCreate: string,
    InstructorProfile: string,
    InstructorSearch: string,
}

export const instructorPaths: InstructorPaths = {
    InstructorEdit: '/instructors/edit/:idParam',
    InstructorCreate: '/instructors/create/:accountIdParam',
    InstructorProfile: '/instructors/view/:idParam',
    InstructorSearch: '/instructors/search',
};

export interface IInstructorProfileTabs {
    sessions: RouteTabParameter;
    details: RouteTabParameter;
}

export const instructorProfileTabs: IInstructorProfileTabs = {
    details: new RouteTabParameter(0, 'Details', 'details'),
    sessions: new RouteTabParameter(1, 'Sessions', 'sessions'),
}
0
export const profileTabs = [
    instructorProfileTabs.details,
    instructorProfileTabs.sessions
];

export const getInstructorProfileTab = (query: string | undefined | null) => profileTabs.find(x => x.query === query);
